import { api } from "@/shared/api/client";
import type { Paginated, RenewalParams, RenewalRow } from "./types";
import { PAGE_SIZE } from "./types";
import { mockRenewals } from "./mock";

// Same mock toggle convention as customers/metrics: flip with `VITE_USE_MOCK=false`.
const USE_MOCK =
  (import.meta.env.VITE_USE_MOCK ?? "true").toString().toLowerCase() !== "false";

const delay = (ms = 250) => new Promise<void>((r) => setTimeout(r, ms));

export async function listRenewals(params: RenewalParams): Promise<Paginated<RenewalRow>> {
  if (USE_MOCK) {
    await delay();
    return mockRenewals(params);
  }
  const res = await api.get<Paginated<RenewalRow>>("/support/renewals/", {
    params: {
      status: params.status,
      days: params.days,
      kind: params.kind,
      search: params.search || undefined,
      ordering: params.ordering || undefined,
      page: params.page,
      page_size: PAGE_SIZE,
    },
  });
  return res.data;
}
